import React from "react";

const Footer = () => {
  return (
    <>
      {/* Quick Reference Section */}
      <div className="quick-reference">
        <div className="reference-section">
          <h3>🟢 You're Safe, Girlfriend! 💅</h3>
          <div className="food-list">
            <span>🍗 Chicken</span>
            <span>🐟 Fish</span>
            <span>🥬 Vegetables</span>
            <span>🍎 Fruits</span>
            <span>🥜 Nuts</span>
            <span>🌾 Grains</span>
          </div>
        </div>

        <div className="reference-section">
          <h3>🔴 Nope, Not Today! 😤</h3>
          <div className="food-list">
            <span>🥩 Beef</span>
            <span>🐷 Pork</span>
            <span>🐑 Lamb</span>
            <span>🦌 Venison</span>
            <span>🧀 Gelatin</span>
            <span>🥛 Dairy</span>
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About This App</h3>
            <p>
              Dana's Food Detective helps people make safer food choices by
              analyzing ingredients and suggesting safe alternatives.
            </p>
            <p>Created with love for food safety and health awareness.</p>
          </div>

          <div className="footer-section">
            <h3>About Alpha-Gal</h3>
            <p>
              Alpha-Gal Syndrome is a food allergy to red meat caused by Lone
              Star tick bites.
            </p>
            <p>
              <a
                href="https://www.cdc.gov/alpha-gal-syndrome/about/index.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                CDC
              </a>{" "}
              •
              <a
                href="https://www.aaaai.org/tools-for-the-public/conditions-library/allergies/alpha-gal-and-red-meat-allergy"
                target="_blank"
                rel="noopener noreferrer"
              >
                AAAAI
              </a>{" "}
              •
              <a
                href="https://www.yalemedicine.org/conditions/alpha-gal-syndrome-ags"
                target="_blank"
                rel="noopener noreferrer"
              >
                Yale
              </a>
            </p>
            <p className="disclaimer">
              For informational purposes only. Consult your healthcare provider.
              <br />
              <a 
                href="/disclaimer.html" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: "#ffd700", textDecoration: "underline" }}
              >
                📋 Full Medical Disclaimer
              </a>
            </p>
          </div>

          <div className="footer-section">
            <h3>Need Your Own App?</h3>
            <p>
              Looking for a custom web application for your business or personal
              use?
            </p>
            <p>
              <a
                href="https://flyingfoxtoolbox.com"
                target="_blank"
                rel="noopener noreferrer"
                className="business-link"
              >
                <img
                  src="/flying-fox-logo.png"
                  alt="Flying Fox Solutions - Colorful Fox Logo"
                  className="flying-fox-logo colorful-fox-logo"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
                Flying Fox Solutions
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
